<template>
	<div class="display-flex flex-column on-boarding-step-wrapper">
		<div class="on-boarding-step-explanation-text">
			The best way to learn is by doing.<br />Choose a tutorial below and we’ll talk you through building your first feature
		</div>
		<OnBoardingBuildYourFirstItem
			class="mt-4"
			v-on="$listeners"
			:key="subStep.id"
			:subStepDetails="subStep"
			@startTutorial="startTutorial"
			v-for="subStep in stepDetails.subSteps"
			:class="{ 'not-active-sub-step': subStep.isCompleted }"
		/>
	</div>
</template>

<script>
import { mapActionsShorthand } from '@/store/utils/mappers';
import { setIsGuidedTutorialOn } from '@/store/modules/onboarding/actions';
import OnBoardingBuildYourFirstItem from '@/components/Onboarding/OnBoardingFlow/OnBoardingSection/OnBoardingSteps/GetBuilding/OnBoardingBuildYourFirstItem.vue';

export default {
	name: 'OnBoardingBuildYourFirst',
	props: { stepDetails: { type: Object } },
	components: { OnBoardingBuildYourFirstItem },
	methods: {
		...mapActionsShorthand({ setIsGuidedTutorialOn }),
		startTutorial(payload) {
			this.$emit('mark-step-as-done', payload.subStepDetails);
			this.$router.push({ name: 'ProjectsRoot' });
			this.setIsGuidedTutorialOn(true);
		},
	},
	data() {
		return {
			isLoading: true,
		};
	},
};
</script>

<style scoped lang="scss">
.not-active-sub-step {
	opacity: 0.2;
	transition: 0.5s;
	&:hover {
		opacity: 0.6;
		transition: 0.5s;
	}
}
</style>
